import React from 'react'
import { Box, Paper, Typography, CircularProgress, Divider, makeStyles } from '@material-ui/core'
import { useQuery } from 'react-query'
import RichContent from 'UI/RichContent'
import { getChangeLogHistory } from 'services/changeLog'
import { USER_ROLE } from 'constants/localStorageKeys'
import { convertDate } from 'utils/formatters'

const useStyles = makeStyles(() => ({
  body: {
    marginTop: '1rem',
  },
}))

const WhatsNewHistory = () => {
  const s = useStyles()
  const { data, isLoading } = useQuery(['changelog-history', localStorage.getItem(USER_ROLE)], getChangeLogHistory)

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p="4rem">
        <CircularProgress color="primary" />
      </Box>
    )
  }

  const entries = data ? data.data : []

  return (
    <Box component={Paper} p="3rem" mb="2rem">
      <Typography variant="h2" color="textSecondary">
        What&apos;s New
      </Typography>

      {entries.length === 0 ? (
        <Box mt="2rem">
          <Typography variant="body1" color="textSecondary">
            There are no updates for your role yet.
          </Typography>
        </Box>
      ) : (
        entries.map((entry, index) => (
          <Box key={entry.id} mt="2.5rem">
            {index > 0 && (
              <Box mb="2.5rem">
                <Divider />
              </Box>
            )}
            <Typography variant="h3" color="textSecondary">
              {entry.name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {convertDate(entry.releaseDate)}
            </Typography>
            <RichContent html={entry.bodyHtml} className={s.body} />
          </Box>
        ))
      )}
    </Box>
  )
}

export default WhatsNewHistory
